import FJLocalStore from '../../../store/FJLocalStore.js';
import ArrowIcon from '../../../assets/button-pull-down.svg?react';
import classNames from 'classnames';
import styles from './FJDropSwitch.module.less';

interface Props {
    className: string;
    style: object;
    text: string;
    isExpand: boolean;
    onClick?: (isExpand: boolean) => void;
}

const FJDropSwitch = ({ className, style, text = '', onClick, isExpand = true }: Props) => {
    const _onClick = () => {
        onClick?.(!isExpand);
    };

    return (
        <div className={classNames(styles.box, className)} style={style} onClick={_onClick}>
            <span className={styles.text}>{FJLocalStore._(text)}</span>
            <ArrowIcon className={isExpand ? undefined : styles.close} />
        </div>
    );
};

export default FJDropSwitch;
